import React, { useState, useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Nav from "./components/Nav";
import HomePage from "./pages/HomePage";
import AssessmentForm from "./pages/AssessmentForm";
import HistoryPage from "./pages/HistoryPage";
import LoginPage from "./pages/LoginPage";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import AdminUsersPage from "./pages/AdminUsersPage";
import AboutPage from "./pages/AboutPage";
import ProfilePage from "./pages/ProfilePage";
import { useAuth } from "./utils/AuthContext";
import ReportBuilder from "./pages/ReportBuilder/ReportBuilder";
import Footer from "./components/Footer";
import UserGuideModal from "./components/UserGuideModal";

function AppShell() {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const isLoginPage = location.pathname === "/login";
  const [guideOpen, setGuideOpen] = useState(false);

  useEffect(() => {
    if (isAuthenticated && !isLoginPage) {
      const isPermanentlyHidden = localStorage.getItem("ahc_hide_user_guide") === "true";
      const justLoggedIn = sessionStorage.getItem("ahc_just_logged_in") === "true";

      if (justLoggedIn) {
        sessionStorage.removeItem("ahc_just_logged_in");
        if (!isPermanentlyHidden) {
          setGuideOpen(true);
        }
      }
    }
  }, [isAuthenticated, isLoginPage]);

  useEffect(() => {
    const handleOpen = () => setGuideOpen(true);
    window.addEventListener("open-user-guide", handleOpen);
    return () => window.removeEventListener("open-user-guide", handleOpen);
  }, []);

  return (
    <div className="app-shell">
      {!isLoginPage && isAuthenticated ? <Nav /> : null}
      <main className={isLoginPage ? "auth-main" : "page-content"}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/assessment/new" element={<AssessmentForm />} />
            <Route path="/assessment/:id/edit" element={<AssessmentForm />} />
            <Route path="/assessment/:id" element={<AssessmentForm />} />
            <Route path="/history" element={<HistoryPage />} />
            <Route path="/reports/new" element={<ReportBuilder />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route element={<AdminRoute />}>
              <Route path="/admin/users" element={<AdminUsersPage />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
      {isAuthenticated && (
        <UserGuideModal
          isOpen={guideOpen}
          onClose={() => setGuideOpen(false)}
        />
      )}
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}
